import React from 'react';

import v from 'components/variables';

export const TRACK_BOARD_VIEW_KEY = 'TRACK_BOARD_VIEW_KEY';
export const LIST_VIEW_KEY = 'LIST_VIEW_KEY';

export const HEADER_SEGMENTED_CONTROL_BUTTONS = [
  {
    label: 'Board',
    buttonValue: TRACK_BOARD_VIEW_KEY,
  },
  {
    label: 'List',
    buttonValue: LIST_VIEW_KEY,
  },
];

export const COMMON_APP_FERPA_PENDING_DESCRIPTION =
  'This student has not completed their FERPA waiver on the Common App site. You will not be able to submit any documents to Common App until they have done so. To do so students must:';
export const FERPA_PENDING_COMMON_APP_STEPS = [
  `Login to your Common App Account. (if you're not already logged in)`,
  'Click on the “Complete Release Authorisation” section',
  'Review the instructions, complete the FERPA Release Authorization  and click “Save and Close”',
];

export const WILL_NOT_COMPLETE_STATUS = -1;
export const IN_PROGRESS_STATUS = 0;
export const COMPLETED_STATUS = 1;
export const WAITLISTED_STATUS = 2;
export const DEFERRED_STATUS = 3;
export const ACCEPTED_STATUS = 4;
export const WITHDRAWN_STATUS = 5;
export const REJECTED_STATUS = 6;

export const INCOMPLETE_STATUSES = [IN_PROGRESS_STATUS];
export const COMPLETE_AND_PENDING_STATUSES = [
  COMPLETED_STATUS,
  WAITLISTED_STATUS,
  DEFERRED_STATUS,
];
export const COMPLETE_PENDING_AND_RESULT_STATUSES = [
  COMPLETED_STATUS,
  WAITLISTED_STATUS,
  DEFERRED_STATUS,
  ACCEPTED_STATUS,
  REJECTED_STATUS,
];
export const ACCEPTED_STATUSES = [ACCEPTED_STATUS];
export const WITHDRAWN_STATUSES = [WITHDRAWN_STATUS];
export const DECLINED_STATUSES = [REJECTED_STATUS];
export const WILL_NOT_COMPLETE_STATUSES = [WILL_NOT_COMPLETE_STATUS];

export const INCOMPLETE_KEY = 'incomplete';
export const COMPLETED_PENDING_KEY = 'completed_pending';
export const ACCEPTED_KEY = 'accepted';

export const COLUMN_TITLE_INFO = {
  [INCOMPLETE_KEY]: {
    label: 'Incomplete',
    countColor: 'red',
    description: (
      <>
        Edit an application below to <b>request recommendations</b> or{' '}
        <b>update checklist</b>.
      </>
    ),
    emptyText: 'Add an application to request transcripts and counselor docs.',
    popoverText:
      'To move an application to the Completed column, complete your student checklist and request all required recommendations.',
  },
  [COMPLETED_PENDING_KEY]: {
    label: 'Completed & pending',
    countColor: 'orangeDark',
    description: (
      <>
        Select a completed application below to <b>update results</b> or{' '}
        <b>track documents</b>.
      </>
    ),
    emptyText:
      'Complete the student checklist to mark an application completed.',
    popoverText:
      'To move an application to the Accepted column, add a result to a pending application',
  },
  [ACCEPTED_KEY]: {
    label: 'Accepted',
    countColor: 'greenDark',
    description: (
      <>
        Be sure to upload <b>award letters</b> and add an{' '}
        <b>enrollment decision</b>.
      </>
    ),
    emptyText: 'Add a result to a mark a completed application as accepted.',
  },
};

export const TARGET_KEY = 'target';
export const LIKELY_KEY = 'likely';
export const REACH_KEY = 'reach';
export const FAR_REACH_KEY = 'far_reach';

export const APPLICATION_TYPE_OPTIONS = [
  { id: 'REGULAR_DECISION', label: 'Regular Decision', icon: 'circle' },
  { id: 'ROLLING', label: 'Rolling', icon: 'square' },
  { id: 'PRIORITY', label: 'Priority', icon: 'circle-with-peaks' },
  { id: 'EARLY_ACTION', label: 'Early Action', icon: 'star' },
  { id: 'EARLY_ACTION_2', label: 'Early Action II', icon: 'star' },
  { id: 'EARLY_DECISION', label: 'Early Decision', icon: 'triangle' },
  { id: 'EARLY_DECISION_2', label: 'Early Decision II', icon: 'rhombus' },
  {
    id: 'RESTRICTED_EARLY_ACTION',
    label: 'Restricted Early Action',
    icon: 'hexagon',
  },
  { id: 'OTHER', label: 'Other', icon: 'cloud' },
];

export const COMMON_APP_NAME = 'Common App';

export const STATUS_MAP = Object.freeze({
  [ACCEPTED_STATUS]: {
    label: `😀 Accepted`,
    color: v.greenExtraLight,
    sortValue: 0,
  },
  [DEFERRED_STATUS]: {
    label: `⌛️ Deferred`,
    color: v.orangeExtraLight,
    sortValue: 1,
  },
  [WAITLISTED_STATUS]: {
    label: `🕓 Waitlisted`,
    color: v.orangeExtraLight,
    sortValue: 2,
  },
  [COMPLETED_STATUS]: {
    label: `❓ Completed & pending`,
    color: v.yellowExtraLight,
    sortValue: 3,
  },
  [IN_PROGRESS_STATUS]: {
    label: `✏️ In progress`,
    color: v.blueSteelExtraLight,
    sortValue: 5,
  },
  [WITHDRAWN_STATUS]: {
    label: `📤 Withdrawn`,
    color: v.grayLight,
    sortValue: 4,
  },
  [WILL_NOT_COMPLETE_STATUS]: {
    label: `❌ Will not complete`,
    color: v.grayExtraLight,
    sortValue: 7,
  },
  [REJECTED_STATUS]: {
    label: `😕 Denied`,
    color: v.redExtraLight,
    sortValue: 6,
  },
});

export const ADD_COLLEGE_STATUS_LIST = [
  {
    id: IN_PROGRESS_STATUS,
    label: 'In progress',
    emoji: '✏️',
  },
  {
    id: COMPLETED_STATUS,
    label: 'Completed & pending results',
    emoji: '❓',
  },
  {
    id: ACCEPTED_STATUS,
    label: 'Accepted',
    emoji: '😃',
  },
  {
    id: REJECTED_STATUS,
    label: 'Denied',
    emoji: '😕',
  },
  {
    id: WAITLISTED_STATUS,
    label: 'Waitlisted',
    emoji: '🕓',
  },
  {
    id: DEFERRED_STATUS,
    label: 'Deferred',
    emoji: '⌛',
  },
  {
    id: WITHDRAWN_STATUS,
    label: 'Withdrawn',
    emoji: '📤',
  },
];

/** @todo remove it and use COLLEGE_APPLICATIONS_ONBOARDING insider userBooleans  */
export const COLLEGE_APPLICATIONS_ONBOARDING_BOOLEAN =
  'college_applications_onboarding';

export const EMPTY_SEARCH_TEXTS = {
  [INCOMPLETE_KEY]: 'No incomplete applications found',
  [COMPLETED_PENDING_KEY]: 'No completed applications found',
  [ACCEPTED_KEY]: 'No accepted applications found',
};

export const SORT_FIELDS = Object.freeze({
  COLLEGE_NAME: 'college_name',
  DUE_DATE: 'submission_due_date',
  STATUS: 'status',
});
